import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, fromEvent, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScreenResizeService {

    private resizeSubject: BehaviorSubject<string>;

    constructor() {
        this.resizeSubject = new BehaviorSubject(this.getScreenSize(window.innerWidth));
        fromEvent(window, 'resize').pipe(
            map(event => {
                return this.getScreenSize(event.target['innerWidth']);
            })
        ).subscribe(this.resizeSubject);
    }
    
    get onResize$() {
        return this.resizeSubject.asObservable();
    }

    getScreenSize(screenWidth) {
        const screenSizes = [
            { width: 1399.98, size: 'xxl' },
            { width: 1199.98, size: 'xl' },
            { width: 991.98, size: 'lg' },
            { width: 767.98, size: 'md' },
            { width: 575.98, size: 'sm' },
            { width: 0, size: 'xs' }
        ];
        return screenSizes.find(s => screenWidth >= s.width).size;
    }

}














